import { render, staticRenderFns } from "./SettingsAccountTab.vue?vue&type=template&id=2ac8f980&"
import script from "./SettingsAccountTab.vue?vue&type=script&lang=js&"
export * from "./SettingsAccountTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports